var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconLoginHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7656 18C13.1231 18 15.384 17.1571 17.051 15.6569C18.718 14.1566 19.6545 12.1217 19.6545 10C19.6545 7.87827 18.718 5.84344 17.051 4.34315C15.384 2.84285 13.1231 2 10.7656 2",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7656 18C13.1231 18 15.384 17.1571 17.051 15.6569C18.718 14.1566 19.6545 12.1217 19.6545 10C19.6545 7.87827 18.718 5.84344 17.051 4.34315C15.384 2.84285 13.1231 2 10.7656 2",
    stroke: "#02215F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 10H12.9861M12.9861 10L9.65278 7M12.9861 10L9.65278 13",
    stroke: "#02215F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconLoginHeader);
export default __webpack_public_path__ + "static/media/buttonIconLoginHeader.c84b3eba8f12080f7f69d2b58d9d000b.svg";
export { ForwardRef as ReactComponent };